import { Injectable } from '@angular/core';

/**
 * Internal service specificaly to this Main Header component.
 *
 * The Main Header component takes focus away from HTML elements when its menu opens.
 * This service ensures that focus returns to the last interacted element outside
 * the Main Header menu once the menu is closed.
 *
 * This mainly apply to all sorts of text fields where the text editing experience should not be interuppted
 */
@Injectable({ providedIn: 'root' })
export class FocusGrabWorkaroundService {
    private lastFocusedElement: HTMLElement | null = null;

    public setHtmlToFocus(event: MouseEvent): void {
        if (this.elementIsOutsideOfTopBar(event)) {
            const activeElement = document.activeElement as HTMLElement;
            this.lastFocusedElement = activeElement;
        }
    }

    public restoreFocus(): void {
        setTimeout(() => {
            if (this.lastFocusedElement instanceof HTMLInputElement || this.lastFocusedElement instanceof HTMLTextAreaElement) {
                const selectionStart = this.lastFocusedElement.selectionStart;
                const selectionEnd = this.lastFocusedElement.selectionEnd;

                this.lastFocusedElement.focus();
                this.lastFocusedElement.setSelectionRange(selectionStart, selectionEnd);
            } else {
                this.lastFocusedElement?.focus();
            }
        }, 0);
    }

    private elementIsOutsideOfTopBar(event: MouseEvent): boolean {
        const target = event.relatedTarget as HTMLElement;
        const menuOverlayContainer = document.getElementsByClassName('cdk-overlay-container');

        if (menuOverlayContainer.length === 0 || !menuOverlayContainer[0].contains(target)) {
            return true;
        }
        return false;
    }
}
